import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { esSupervisorDps, rutaPermitidaSupervisorDps } from '../../utils/roles';

const PrivateRoute = ({ element }) => {
    const { isAuthenticated, user } = useSelector((state) => state.auth);
    const location = useLocation();

    if (!isAuthenticated) {
        return <Navigate to="/" />;
    }

    // Supervisor DPS: solo los módulos habilitados para su rol.
    if (esSupervisorDps(user) && !rutaPermitidaSupervisorDps(location.pathname)) {
        return <Navigate to="/acceso-restringido" />;
    }

    return element;
};

export default PrivateRoute;
